import { boolean, object, optional } from 'superstruct';
import { EditPermissionsDto } from '@arc/shared/util-data';
import { userString } from '@arc/shared/util-superstruct';
export const AddRoleDto = object({
  name: userString('validations:Required'),
  superuser: optional(boolean()),
  permissions: optional(EditPermissionsDto),
  archived: optional(boolean())
});